export const filterColumns = (dataColumns, allColumns) =>
  allColumns.filter(column => dataColumns.indexOf(column.data_key) !== -1)
